import React, { useContext, useState } from "react";
import { Input } from "..";
import { ResumeContext } from "../../contexts/resumeContext";
import { Edit } from "../Icons/Icons";
import styles from "./Heading.module.css";

function Heading(props) {
  const {resumeHeadings, setResumeHeadings} = useContext(ResumeContext);
  const [isEditing, setIsEditing] = useState(false);
  const [content, setContent] = useState(resumeHeadings[props.section] || props.content)
  const handleEdit = () => {
    setIsEditing(false);

    const resumeHeadingsTemp = {...resumeHeadings};
    resumeHeadingsTemp[props.section] = content;
    setResumeHeadings(resumeHeadingsTemp)
  }

  return (
    <>
      <div className={styles.editWrapper}>
        {isEditing ? (
          <input autoFocus value={content} onBlur={handleEdit} onChange={e => setContent(e.target.value)}/>
        ) : (
          <div
            contentEditable={isEditing}
            className={styles.heading + " " + props.className}
            style={{ ...props.style }}
          >
            {content || props.children}
          </div>
        )}
        
        {props.editable && <Edit onClick={() => setIsEditing(true)} />}
      </div>
      {props.subheading && (
        <p className={styles.subheading}>{props.subheading}</p>
      )}
    </>
  );
}

export default Heading;
